import script from "./UiDropdownMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./UiDropdownMenu.vue?vue&type=script&setup=true&lang=ts"

import "./UiDropdownMenu.vue?vue&type=style&index=0&id=2cc71c11&scoped=true&lang=css"

import exportComponent from "C:\\inetpub\\wwwroot\\agrii-carrier-prod\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2cc71c11"]])

export default __exports__